<template>
    <div class="pb-4 relative">
        <div class="wrapper-input"
            :class="[isError ? 'error' : 'active']">
            <input :type="type"
                :id="id"
                class="input-data"
                v-model="content"
                :minlength="inputMinLength"
                :maxlength="inputMaxLength"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)">
            <label :for="id"
                class="title-label"
                :class="[{'transition-label-no-content': !content && !focusText},
                        {'transition-label-content': content || focusText},
                        ]"
            >{{inputLbl.name}}</label>
            <div v-if="content && content.length > 0" class="ic-pass" @click="clickShowPassword()">
                    <img v-if="isShowPassword" src="@/assets/icon/ic-show-pass.png" alt="">
                    <img v-else src="@/assets/icon/ic-hide-pass.png" alt="">
                </div>
        </div>
        <div class="text-error" v-if="!errorInfo.isValid"
             v-show="!errorInfo.isValid">{{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Boolean} isTextOnly (optional) Only text.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "Password",
    props: {
        // v-model
        value:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        isTextOnly:     { type: Boolean, default: false },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        isPassword:     { type: Boolean, default: false },
        isConfirmPassword:    { type: Boolean, default: false },
        passWord:       { type: String, default: ''},
        // text
        inputLbl:       { type: Object, required: true },
        inputId:        { type: String, default: 'input'},
        isRemoveThai:        { type: Boolean, default: false}
    },
    data: function() {
        return {
            id: '',
            content: this.value,
            inputMinLength: null,
            inputMaxLength: null,
            focusText: false,
            isShowPassword: false,
            type: 'password',
            pass: ''
        };
    },
    watch: {
        passWord: function(newItem){
            if(newItem){
                this.pass = newItem;
                // this.checkTypeId();
            }
        },
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
    },
    created: function () {
        // let randId = Math.floor(Math.random() * 100000);
        this.id = this.inputId;

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
        this.inputMinLength = this.minLength;
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        clickShowPassword: function () {
            // var password = this.content;
            if (this.type == "password") {
                this.type = "text";
                this.isShowPassword = true;
            } else {
                this.type = "password";
                this.isShowPassword = false;
            }
        },
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.inputMinLength
                && (this.content && this.content.length < this.inputMinLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.too_short);
                return;
            }
            //InValid format
            if (this.inputLbl.invalid && this.content) {
                if (!this.validPasswordFormat(this.content)) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
            //not match
            if (this.isConfirmPassword) {
                if (this.pass != this.content && this.content) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.match);
                    return;
                }
            }
        },
        onChange: function() {
            var result = this.content;

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }
            if (this.isRemoveThai) {
                result = RegxHelper.removeThai(result)
            }

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        validPasswordFormat: function (password) {
            if (!password) {
                return;
            }

            let validPasswordLength = false;
            if (password.length >= this.minLength) {
                validPasswordLength = true;
            }
            if (password.length > this.maxLength) {
                validPasswordLength = false;
            }

            let upperCase = (/.*[A-Z].*/).test(password);
            let lowerCase = (/.*[a-z].*/).test(password);
            let hasSpecial = (/[-!$@฿#%^&*()_+|~=`{}[\]:";'<>?,./]/).test(password);
            let hasNumber = (/[0-9]/).test(password);

            if (password != '' && validPasswordLength && (upperCase || lowerCase) && hasNumber && !hasSpecial) {
                return true;
            } else {
                return false;
            }
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
   @import "@/style/Input/Input.scss";

    input::-ms-clear, input::-ms-reveal {
        display: none;
    }
</style>
